import { Directive, inject } from '@angular/core';
import { GridComponent as KendoGridComponent, RowSelectedFn } from '@progress/kendo-angular-grid';

/**
 * The sole purpose of this is to capture the default "rowSelected" value before it gets overridden.
 */
@Directive({ selector: 'kendo-grid', standalone: true })
export class DefaultRowSelectedAccessorDirective {
    private grid = inject(KendoGridComponent);

    readonly defaultRowSelected: RowSelectedFn;

    constructor() {
        this.defaultRowSelected = this.grid.rowSelected;
    }
}
